import * as Waypoint from 'react-waypoint'
import { setContainerPosition } from './reducer'
import { connect } from 'react-redux'
import { CategoryMenu as component } from './component'
import { setCategory } from '../hotelCategory/reducer'

const mapStateToProps = ({ containerPosition, activeCategory }) => {
  return {
    menuAttachement: containerPosition,
    activeCategory
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onLeaveHandler: ({ currentPosition }) => {
      if (currentPosition === Waypoint.above) {
        dispatch(setContainerPosition('fixed'))
      }
    },
    onEnterHandler: () => {
      dispatch(setContainerPosition('static'))
      dispatch(setCategory('cat-0'))
    }
  }
}

const container = connect(mapStateToProps, mapDispatchToProps)(component)

export { container as CategoryMenu }



// WEBPACK FOOTER //
// ./src/components/categoryMenu/index.js